import state from '@state';
import { initAudioRecording } from '@voice/recorder';
import { log } from '@utils/logger';
import { Instance } from 'types';
import { getMicrophoneIcon } from '@utils/icons';
import i18n from '@i18n';

/**
 * Creates or enhances the voice search button in the form,
 * and wires it up to audio recording functionality.
 *
 * @param form - The HTML form element to enhance with a voice search button.
 */
export function setupVoiceButton(form: HTMLFormElement, searchInput: HTMLInputElement, instance: Instance): void {
	if (!form) {
		return;
	}

	// Attempt to find the voice button in the form
	let voiceButton = form.querySelector('.aex-voice-button') as HTMLButtonElement | null;

	if (instance.voiceSearchButton) {
		voiceButton = form.querySelector(instance.voiceSearchButton) as HTMLButtonElement | null;
	}

	// If not present, create and insert one
	if (!voiceButton) {
		voiceButton = document.createElement('button');
		voiceButton.type = 'button';
		voiceButton.innerHTML = getMicrophoneIcon();

		// Try to insert it near the input
		if (searchInput && searchInput.parentNode) {
			searchInput.parentNode.insertBefore(voiceButton, searchInput.nextSibling);
		} else {
			form.appendChild(voiceButton); // fallback
		}
	}

	voiceButton.classList.add('aex-voice-button');

	if (!navigator.mediaDevices || !window.MediaRecorder) {
		voiceButton.remove();
		return;
	}

	// Wire up the audio recorder
	const audioRecorder = initAudioRecording();

	if (audioRecorder) {
		if (!voiceButton.dataset.listenerAttached) {
			voiceButton.addEventListener('click', () => {
				state.currentInstance = instance;

				if (state.isRecording) {
					audioRecorder.stop();
				} else {
					audioRecorder.start();
				}
			});
			voiceButton.dataset.listenerAttached = 'true';
		}
	} else {
		voiceButton.disabled = true;
		voiceButton.title = i18n.t('error.audioError');
		log(i18n.t('error.audioError'));
	}
}
